module.exports = __webpack_public_path__ + "img/balkonglasdach_1.c5d16851.jpg";